import React, { useEffect, useRef, useState } from "react";
import csLogo from "../../../Assets/images/admin/CS-LOGO-HORIZONTAL.png";
import html2pdf from "html2pdf.js";

import { useReactToPrint } from "react-to-print";
import {
  Modal,
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@mui/material";
import { apiAdminConfig } from "../../../utils/api";
import Loader from "../../../Components/Loader/Loader";

export default function ViewInvoiceModal({
  isOpen,
  onClose,
  id,
  driverDetails,
}) {
  // console.log("driver details ",driverDetails)
  const [invoiceDetails, setInvoiceData] = useState();
  const [address, setAddress] = useState();
  // console.log("There is a data = ", invoiceDetails)
  const invoiceRef = useRef();
  // console.log("invoiceDetails : ",invoiceDetails)

  const [loading, setLoading] = useState(true);
  const platformFee = 1;

  useEffect(() => {
    const fetchInvoice = async () => {
      setLoading(true);
      try {
        const response = await apiAdminConfig.get(
          `/api/auth/invoice/view/${id}`
        );
        if (response.status === 200) {
          setInvoiceData(response.data);
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchInvoice();
  }, [id]);

  // 2. Once invoice data is loaded, then fetch address
  useEffect(() => {
    const fetchAddress = async () => {
      if (
        invoiceDetails?.invoice?.job?.created_by &&
        invoiceDetails?.invoice?.billed_to
      ) {
        setLoading(true);
        try {
          const response = await apiAdminConfig.get(
            `/api/auth/master/${invoiceDetails.invoice.job.created_by}/view/${invoiceDetails.invoice.billed_to}`
          );
          if (response.status === 200) {
            setAddress(response?.data?.view_data);
          }
        } catch (error) {
          console.log("error=====>", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchAddress();
  }, [invoiceDetails]);
  // console.log(address)
  const handlePrint = useReactToPrint({
    content: () => {
      console.log("invoiceRef.current inside print:", invoiceRef.current);
      return invoiceRef.current;
    },
    onAfterPrint: () => {
      console.log("Print successful");
    },
    onPrintError: (error) => {
      console.error("Print error:", error);
    },
  });

  const handleDownloadPDF = () => {
    const element = invoiceRef.current;
    const opt = {
      margin: 0.3,
      filename: `invoice_${invoiceDetails?.invoice?.id || "file"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };
    html2pdf().set(opt).from(element).save();
  };

  const formatDate = (rowDate) => {
    const date = new Date(rowDate);
    return date.toLocaleString("en-UK", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };
  const formatDateWithTime = (rowDate) => {
    const date = new Date(rowDate);
    return date.toLocaleString("en-UK", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  if (!id) {
    return (
      <Modal open={isOpen}>
        <Box sx={modalStyles.box}>
          The invoice will be generated once the job is marked as completed.
        </Box>
      </Modal>
    );
  }

  if (!isOpen) return null;

  if (loading) {
    return (
      <Modal open={isOpen}>
        <Box sx={modalStyles.box}>
          <Loader />
        </Box>
      </Modal>
    );
  }

  if (!invoiceDetails?.invoice) return null;

  const invoiceAmount = Number(invoiceDetails?.invoice?.amount || 0);
  
  const platformFeeAmount = invoiceDetails?.invoice?.billed_by_user?.company_vat ? platformFee : platformFee+0.20;
  const vatAmount = invoiceDetails?.invoice?.billed_by_user?.company_vat
    ? (invoiceAmount + platformFeeAmount) * 0.2
    : 0;
  const totalAmount = (invoiceAmount + platformFeeAmount + vatAmount).toFixed(2);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      keepMounted
      aria-labelledby="invoice-modal-title"
    >
      <Box sx={modalStyles.box} onClick={(e) => e.stopPropagation()}>
        <Typography
          id="invoice-modal-title"
          variant="h4"
          component="h2"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Invoice Details
        </Typography>

        <Box ref={invoiceRef} sx={containerStyle}>
          <Box sx={pdfContainerStyle}>
            <Box style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={csLogo}
                alt="CS Logo"
                style={{
                  width: "100%",
                  maxWidth: "150px",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </Box>

            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 4 }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography variant="h6">
                  Invoice To:{" "}
                  {invoiceDetails?.invoice?.billed_to_user?.user_name}
                </Typography>

                <Typography variant="body1" sx={{ mt: 3 }}>
                  Customer Member ID: {invoiceDetails?.invoice?.billed_to}
                </Typography>
                <Typography variant="body1">
                  {invoiceDetails?.invoice?.billed_to_user?.address}{" "}
                  {invoiceDetails?.invoice?.billed_to_user?.city},{" "}
                  {invoiceDetails?.invoice?.billed_to_user?.state}, (
                  {invoiceDetails?.invoice?.billed_to_user?.zip_code})
                </Typography>
              </Box>
              <Box sx={{ flex: 1, textAlign: "right" }}>
                <Typography variant="h6">
                  Invoice from:{" "}
                  {invoiceDetails?.invoice?.billed_by_user?.user_name}
                </Typography>
                {/* Paid/Unpaid tag based on job.is_paid */}
                <Box
                  sx={{
                    mt: 1,
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                  }}
                >
                  <Chip
                    label={
                      invoiceDetails?.invoice?.job?.is_paid === 1
                        ? "Paid"
                        : "Unpaid"
                    }
                    color={
                      invoiceDetails?.invoice?.job?.is_paid === 1
                        ? "success"
                        : "error"
                    }
                    size="small"
                  />
                </Box>
                <Typography>
                  {invoiceDetails?.invoice?.billed_by_user?.address}{" "}
                  {invoiceDetails?.invoice?.billed_by_user?.city},{" "}
                  {invoiceDetails?.invoice?.billed_by_user?.state}, (
                  {invoiceDetails?.invoice?.billed_by_user?.zip_code})
                </Typography>
                <Typography>
                  Tel.: {invoiceDetails?.invoice?.billed_by_user?.dial_code}{" "}
                  {invoiceDetails?.invoice?.billed_by_user?.mobile}
                </Typography>
                <Typography>
                  Email: {invoiceDetails?.invoice?.billed_by_user?.email}
                </Typography>
                <Typography variant="h6" sx={{ mt: 2 }}>
                  Driver Member ID:{" "}
                  {invoiceDetails?.invoice?.billed_by_user?.user_id}
                </Typography>
                <Typography>
                  <strong>
                    Invoice No :{" "}
                    {invoiceDetails?.invoice?.created_at &&
                    invoiceDetails?.invoice?.id
                      ? `${new Date(invoiceDetails.invoice.created_at)
                          .toISOString()
                          .slice(0, 10)
                          .replace(/-/g, "")}00${invoiceDetails.invoice.id}`
                      : ""}
                  </strong>
                </Typography>

                <Typography>
                  <strong>
                    Invoice Date:{" "}
                    {formatDate(invoiceDetails?.invoice?.created_at)}
                  </strong>
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
            ></Box>
            <TableContainer component={Paper}>
              <Table sx={tableStyles}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={tableCellStyles}>Qty</TableCell>
                    <TableCell sx={tableCellStyles}>Description</TableCell>
                    <TableCell sx={tableCellStyles}>Unit Cost</TableCell>
                    <TableCell sx={tableCellStyles}>Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell sx={tableCellStyles}>
                      {invoiceDetails?.invoice?.job_items.map((item, key) => (
                        <>{item?.quantity}</>
                      ))}
                    </TableCell>
                    <TableCell sx={tableCellStyles}>
                      <Typography>
                        <strong>Date Ordered:</strong>{" "}
                        {formatDateWithTime(
                          invoiceDetails?.invoice?.created_at,
                        )}
                        <br />
                        <strong>Your job:</strong>{" "}
                        {invoiceDetails?.invoice.job?.name}
                        <br />
                        {(() => {
                          const pickup =
                            invoiceDetails?.invoice.item_address?.find(
                              (addr) => addr?.type === "pickup",
                            );
                          return (
                            <>
                              <strong>Pick up from:</strong> {pickup?.address},
                              ({pickup?.pin_code})
                              <br />
                            </>
                          );
                        })()}
                        {invoiceDetails?.invoice?.job_items.map((item, key) => (
                          <>
                            <strong>Pick up Date & Time:</strong>{" "}
                            {item?.pickup_date} {item?.pickup_time}
                          </>
                        ))}
                        <br />
                        <strong>Vehicle type:</strong>{" "}
                        {invoiceDetails?.invoice.job?.vehical_type}
                        <br />
                        <strong>Vehicle:</strong>{" "}
                        {
                          JSON.parse(
                            invoiceDetails.invoice.job?.vehicle || "[]",
                          )[0]
                        }
                        <br />
                        {(() => {
                          const pickup =
                            invoiceDetails?.invoice.item_address?.find(
                              (addr) => addr?.type === "drop",
                            );
                          return (
                            <>
                              <strong>Delivered to:</strong> {pickup?.address},
                              ({pickup?.pin_code})
                              <br />
                            </>
                          );
                        })()}
                        {invoiceDetails?.invoice?.job_items.map((item, key) => (
                          <>
                            <strong>Delivery Date & Time:</strong>{" "}
                            {item?.drop_date} {item?.drop_time}
                          </>
                        ))}
                      </Typography>
                    </TableCell>
                    <TableCell sx={tableCellStyles}>
                      £{invoiceDetails?.invoice?.amount}
                    </TableCell>
                    <TableCell sx={tableCellStyles}>
                      £{invoiceDetails?.invoice?.amount}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <Box
              sx={{
                display: "contents",
                justifyContent: "space-between",
                mt: 5,
                padding: 10,
              }}
            >
              <Box sx={{ textAlign: "center", flex: 1 }}>
                <Typography>
                  <strong>
                    Please make the payment first to start the job
                  </strong>
                </Typography>
              </Box>
              <TableContainer component={Paper} sx={{ flex: 1 }}>
                <Table sx={tableStyles}>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={tableCellStyles}>Subtotal</TableCell>
                      <TableCell sx={tableCellStyles}>
                        £{Number(invoiceDetails?.invoice?.amount || 0).toFixed(2)}
                      </TableCell>
                    </TableRow>
                    
                      <TableRow>
                        <TableCell sx={tableCellStyles}>Platform Fee</TableCell>
                        <TableCell sx={tableCellStyles}>
                          £{platformFeeAmount.toFixed(2)} {!invoiceDetails?.invoice?.billed_by_user?.company_vat ? "(including vat)":""}
                        </TableCell>
                      </TableRow>
                    

                    {invoiceDetails?.invoice?.billed_by_user?.company_vat && (
                      <TableRow>
                        <TableCell sx={tableCellStyles}>VAT (20%)</TableCell>
                        <TableCell sx={tableCellStyles}>
                          £{vatAmount.toFixed(2)}
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell sx={tableCellStyles}>Total</TableCell>
                      <TableCell sx={tableCellStyles}>£{totalAmount}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box sx={{ mt: 1 }}>
              <Typography
                variant="h6"
                component="div"
                sx={{ borderBottom: "1px solid #ccc", pb: 1 }}
              >
                Notes
              </Typography>
              <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
                <Typography>
                  {invoiceDetails?.invoice.job?.description}
                </Typography>
              </Paper>
            </Box>

            <Box sx={{ textAlign: "center", mt: 1 }}>
              <Typography>
                <strong>VAT Number:</strong>{" "}
                {invoiceDetails?.invoice?.billed_by_user?.company_vat
                  ? `${invoiceDetails?.invoice?.billed_by_user?.company_vat}`
                  : "492274569"}
              </Typography>
              <hr />
            </Box>

            {invoiceDetails?.invoice?.job?.created_by === "company" && (
              <Typography sx={{ textAlign: "center" }}>
                <strong>
                  Please pay within 15 days from the date of this invoice.
                </strong>
              </Typography>
            )}
          </Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Box sx={{ display: "flex", gap: "10px" }}>
            {/* <Button
              variant="contained"
              color="primary"
              onClick={handlePrint}
              disabled={!invoiceDetails?.invoice}
            >
              Print as PDF
            </Button> */}

            <Button
              variant="contained"
              color="success"
              onClick={handleDownloadPDF}
            >
              Download as PDF
            </Button>
          </Box>
          <Button variant="outlined" onClick={onClose}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

const modalStyles = {
  box: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxHeight: "90vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    // borderRadius: 1,
  },
};

const containerStyle = {
  maxWidth: "950px",
  margin: "20px auto",
  padding: "20px",
};

const pdfContainerStyle = {
  border: "2px solid #ddd",
  padding: "20px",
  // borderRadius: "8px",
};

const tableStyles = {
  "& .MuiTableCell-root": {
    border: "1px solid #ddd",
  },
};

const tableCellStyles = {
  border: "1px solid #ddd",
  padding: "8px",
};
